<template>
  <header class="header">
    <div class="header__container main-page">
      <router-link to="/" class="header__logo">
        <img src="img/logo.png" alt="" />
      </router-link>
      <div class="header__rightside_block">
        <div class="header__menu">
          <button class="header__menu_item" @click="redirect" v-html="t('welcome.signIn_signUp')">
          </button>
        </div>

        <LanguageSwitcher class="mob-hidden" :class="{'main-page': isAuth === false}" />
      </div>
    </div>
    <div class="header__mob_menu">
      <div id="burger" :class="{'open': menuActive}" @click="menuActive = !menuActive">
        <span> </span><span> </span><span> </span>
      </div>
      <nav class="nav" id="nav" :class="{'nav-open': menuActive}">
        <div class="nav__logo"><img src="img/logo.png" alt="" /></div>
         <li class="header__menu" style="display: flex; padding: .5em .5em">
          <button class="header__menu_item" @click="redirect" v-html="t('welcome.signIn_signUp')" style="font-size: 0.4em;">
          </button>
        </li>
        <li class="language">
          <LanguageSwitcher class="mob-hidden" :class="{'main-page': isAuth === false}" />
        </li>
      </nav>
    </div>
  </header>
</template>

<script>
import { auth } from "@/mixins/auth";
import LanguageSwitcher from '../Language/LanguageSwitcher.vue';
import { useI18n } from "vue-i18n";
import { mapState } from "vuex";
import { transactions } from "@/mixins/transactions";

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return { t };
  },

  components: { LanguageSwitcher },

  props: ["canIRerenderComponent"],

  mixins: [auth, transactions],

  data() {
    return {
      routs: [
        {
          name: "Dashboard",
          path: "/",
        },
        {
          name: "Wallet",
          path: "/wallet",
        },
        {
          name: "My Plans",
          path: "/my-plans",
        },
        {
          name: "My Cases",
          path: "/my-cases",
        },
        {
          name: "My team",
          path: "/my-team",
        },
        {
          name: "Binary",
          path: "/binary",
        },
        {
          name: "Settings",
          path: "/settings",
        },
      ],

      menuActive: false,
      isAuth: false,
      // isAuth: ,
    };
  },

  computed: {
    ...mapState({
      defaultAsset: (state) => state.asset.defaultAsset,
      walletAssetsList: (state) => state.finance.walletAssetsList,
      // asset: (state) => state.asset.asset,
    }),

    balance() {
      const assetBalance = this.walletAssetsList.find(a => a.assetId === this.defaultAsset?.assetId)?.assetBalance ?? 0;

      return this.setDecimalPrice(Number(assetBalance));
    },
  },

  methods: {
    redirect() {
      let ref = '';

      if (localStorage.getItem('referral') !== null) {
        ref = localStorage.getItem('referral') !== null ? '&ref='+localStorage.getItem('referral') : '';
      } else {
        ref = this.$route.query.ref !== undefined ? '&ref='+this.$route.query.ref : '';
      }

      const url = "https://tokenza.io/#/?login"
      // const url = "https://demo.promo/pa/outsource/tokenza/#/?login"

      const resultLink = url+ref;
      window.location =  resultLink
    },

    rerenderComponent() {
      this.$forceUpdate();
    },
  },

  created() {
    this.isAuth = this.getAuthState();

    if (this.walletAssetsList.length === 0) {
      this.$store.dispatch("getWalletAssetsList");
    }
  },

  updated() {
    this.isAuth = this.getAuthState();
  },

  watch: {
    canIRerenderComponent(newValue) {
      if (newValue === true) {
        this.rerenderComponent();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: transparent;
  border: 0;
  cursor: pointer;
}

.header__menu {
  margin: 0 auto;
}
</style>